import { useUser } from "@/contexts/UserContext";
import { useRemainingSession } from "@/helpers/session";
import { AccountCircle, Update as UpdateIcon } from "@mui/icons-material";
import { AppBar, Box, Button, IconButton, Toolbar, Typography } from "@mui/material";
import React from "react";

interface TopbarProps {
  onMenuClick: () => void;
  isMobile: boolean;
  sidebarOpen: boolean;
  sidebarWidth: number;
}

const Topbar: React.FC<TopbarProps> = ({ sidebarOpen, sidebarWidth }) => {
  const { user, isLoading } = useUser();
  const { remainingMs, format, extend } = useRemainingSession();

  const handleExtend = () => {
    extend();
  };

  return (
    <AppBar
      position='fixed'
      sx={{
        zIndex: (theme) => theme.zIndex.appBar,
        width: "100%",
        bgcolor: "#fff",
        boxShadow: "none",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
      }}
    >
      <Toolbar
        sx={{
          minHeight: 64,
          justifyContent: "flex-end",
          width: "100%",
          maxWidth: { xs: "100%", lg: "1920px" },
          mx: "auto",
          pl: { lg: sidebarOpen ? `${sidebarWidth}px` : 0 },
          transition: (theme) =>
            theme.transitions.create(["padding"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        {!isLoading && user && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* 남은 세션 시간 */}
            <Typography
              variant='body1'
              sx={{
                color: "text.primary",
                fontSize: 15,
                fontWeight: 500,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                mr: 2,
              }}
            >
              {format(remainingMs)}
            </Typography>

            {/* 세션 연장 버튼 */}
            <Button
              size='small'
              onClick={handleExtend}
              startIcon={<UpdateIcon />}
              variant='outlined'
              sx={{ mr: 2, textTransform: "none" }}
            >
              연장
            </Button>
            <Box sx={{ height: 32, borderLeft: "1.5px solid #ddd", mr: 2 }} />
            {/* 기존 사용자 정보 */}
            <Typography
              variant='body1'
              sx={{
                color: "text.primary",
                fontSize: 15,
                fontWeight: 500,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 300,
              }}
            >
              {user.name} ({user.email})
            </Typography>
            <IconButton color='default'>
              <AccountCircle fontSize='large' />
            </IconButton>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
